module.exports = __webpack_public_path__ + "img/arrowRightWhite.4a476264.svg";